import { Entity, Field } from 'typegraph';

@Entity({one: "program", many: "programsUser"})
export default class Program {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public description: string;

}



// WEBPACK FOOTER //
// ./src/panels/programs/entities/Program.ts